<template>
  <span>
    <div v-if="filteredLinks.length > 0" class="btn-group">
      <button
        v-for="link in filteredLinks"
        :key="link.id || link.urlTemplate"
        class="btn btn-sm btn-primary mx-2 link-button"
        :class="link.modelName.toLowerCase()"
        @click="goToLink(link.urlTemplate)"
      >
        <i class="fas fa-file me-1"></i>{{ $t(link.name) }}
      </button>
    </div>
  </span>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "CustomLinks",
  props: {
    modelName: {
      type: String,
      required: false,
    },
    section: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      links: [],
    };
  },
  created() {
    this.fetchLinks();
  },
  computed: {
    filteredLinks() {
      return this.links.filter(
        (link) =>
          link.modelName === this.modelName && link.section === this.section
      );
    },
  },
  methods: {
    async fetchLinks() {
      try {
        const response = await wencesApi.get("/api/admin-links", {
          params: {
            modelName: this.modelName,
            section: this.section,
          },
        });
        this.links = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error("Error fetching links:", error);
        this.links = [];
      }
      // El contenedor necesita saber si hay enlaces para no dibujar bloques vacíos.
      this.$emit("links-loaded", this.filteredLinks.length);
    },
    goToLink(template) {
      const url = this.formatUrl(template);
      const baseUrl = window.location.origin;
      window.open(baseUrl + url, "_blank");
    },
    formatUrl(template) {
      if (!template) return "#";

      if (!this.item) return template;

      let url = template;

      // Reemplazar shortcodes del tipo {model->campo}
      url = url.replace(/\{model->([\w_]+)\}/g, (match, field) => {
        const value = this.item[field];
        return value !== undefined ? value : match;
      });

      // Reemplazar shortcodes del tipo {campo}
      url = url.replace(/\{([\w_]+)\}/g, (match, field) => {
        const value = this.item[field];
        return value !== undefined ? value : match;
      });

      return url;
    },
  },
};
</script>

<style scoped>
.custom-links {
  margin-top: 1rem;
}
</style>
